<app-dave-list-card
    [CustomSearchCompareFunction]="customPersonSearchCompare"
    [Headline]="headline"
    [HeaderIcon]="headerIcon"
    [EmptyText]="'Keine Personen vorhanden'"
    [Data]="ShowBeteiligteList$ | async"
    [DisplayedCollums]="['custom']"
    [Clickable]="true"
    (EntryClicked$)="openBeteiligterDialog($event.entry)"
    [CustomCellTemplates]="{ custom: personListEntry }"
    [IsExpandable]="true"
    [Expanded]="expanded">

    <button
        headerButton
        app-round-button
        (click)="filter.Open(); $event.stopPropagation();"
        [matBadge]="FilterAmount$ | async"
        [matBadgeHidden]="(FilterAmount$ | async) === null"
        matTooltip="Filter"
        [matBadgeOverlap]="true"
        class="mat-badge-more-overlay">
        <fa-icon icon="filter"></fa-icon>
    </button>

    <button
        headerButton
        app-round-button
        matTooltipPosition="left"
        matTooltip="Hinzufügen"
        (click)="OpenPersonDialog()"
        [Disabled]="!canAdd">
        <app-double-icon Icon="user" Icon2="plus"></app-double-icon>
    </button>
</app-dave-list-card>
<app-filter-card UnlimitedHeight #filter [Settings]="FilterSettings$ | async" [Values]="FilterValues$ | async" (ValuesChange)="FilterValues$.next($event)"></app-filter-card>

<ng-template #personListEntry let-data="data">
    <app-person-list-entry [Person]="data"></app-person-list-entry>
</ng-template>
